<ul [ngClass]="level > 1 ? 'mr-4' : ''">
  <ng-container *ngFor="let item of destinations">
    <li
      class="flex flex-col p-sm text-gray-ds-300 pr-5 hover:bg-transparency-primary-10 hover:text-primary-500 hover:after:bg-primary-500">
      <a [href]="item.Url">
        <div class="flex items-center justify-between text-p">
          <span>هتل های {{ item.CityTitle || item.StateTitle || item.RegionTitle }}</span>
          <span class="ml-2">({{ item.CountHotelsOfCity || item.CountHotelsOfState || item.CountHotelsOfRegion }})</span>
        </div>
      </a>
    </li>

    <iho-recursive-destinations *ngIf="item.Cities?.length" [destinations]="item.Cities" [level]="level + 1">
    </iho-recursive-destinations>

    <iho-recursive-destinations *ngIf="item.Regions?.length" [destinations]="item.Regions" [level]="level + 1">
    </iho-recursive-destinations>
  </ng-container>
</ul>